import D2C_TariffPlan from './Plan'

class D2C_TariffEarlyBird extends D2C_TariffPlan {
  icon = 'user secret'
  isEarlyBird = true
  static objectType = 'tariffType'
  static active = false
  static hidden = true
  static tariffId = '58c0e19ab2eac50001858819'
  static tariffTitle = 'Early Bird'
  static order = 20
}

export default D2C_TariffEarlyBird
